module.exports = __webpack_public_path__ + "img/c-15.b26a1b97.jpg";